import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useTranslation } from '../../contexts/translation-context';
import { serializeDate } from './helpers';
import styles from './date-components.module.scss';
import { DayFieldWUT } from './day-field/day-field-wut';
import { MonthSelectWUT } from './month-select/month-select-wut';
import { YearFieldWUT } from './year-field/year-field-wut';
import { SupportedDateParts } from '../../utils/date-format-parts';
import { FieldLabelWUT } from '../field-label/field-label-wut';
const dateComponentsWUT = {
  [SupportedDateParts.DAY]: DayFieldWUT,
  [SupportedDateParts.MONTH]: MonthSelectWUT,
  [SupportedDateParts.YEAR]: YearFieldWUT
};
export const getDateComponentWUT = datePart => {
  const Field = dateComponentsWUT[datePart];
  if (!Field) {
    return () => null;
  }
  return function DateComponent(_ref) {
    let {
      id,
      inputId,
      hidePlaceholder,
      showDateLabels,
      onChange,
      values,
      errors,
      ...rest
    } = _ref;
    const {
      t
    } = useTranslation();
    const placeholderText = hidePlaceholder ? undefined : t(`field.date.placeholder.${datePart.toLowerCase()}`);
    const value = values[datePart];
    const hasError = errors[datePart];
    const label = t(`field.date.label.${datePart.toLowerCase()}`);
    return /*#__PURE__*/React.createElement("div", {
      className: styles[datePart]
    }, /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: `form-field-sub-label-${datePart}-${inputId}`,
      label: label,
      hideLabel: !showDateLabels,
      required: false
    }), /*#__PURE__*/React.createElement(Field, _extends({}, rest, {
      id: id,
      error: hasError,
      value: value,
      "data-date-field": true,
      "data-hook": datePart,
      placeholder: placeholderText,
      onChange: newValue => onChange(serializeDate(newValue, datePart, values))
    })));
  };
};
//# sourceMappingURL=date-components-wut.js.map